import React from 'react';
import './styles/promise.css';

const Promise: React.FC = () => {
  return (
    <div className="promise-section">
      <div className="promise-container">

        <div className="promise-card">
          <div className="promise-card-icon">
            <img src="/icon/delivery.png" alt="Delivery" className="delivery-icon" />
          </div>
          <h3 className="card-title">30 Minutes Delivery</h3>
          <p className="card-description">Faster than anyone</p>
        </div>

        <div className="promise-card">
          <div className="promise-card-icon">
            <img src="/icon/orderhome.png" alt="Order" className="order-icon" />
          </div>
          <h3 className="card-title">Order</h3>
          <p className="card-description">Select Materials and Services</p>
        </div>

        <div className="promise-card">
          <div className="promise-card-icon">
            <img src="/icon/zaphome.png" alt="Fast Dispatch" className="dispatch-icon" />
          </div>
          <h3 className="card-title">Zap</h3>
          <p className="card-description">Fast Dispatch in 30 Minute</p>
        </div>

        <div className="promise-card">
          <div className="promise-card-icon">
            <img src="/icon/firststep.png" alt="Fast Dispatch" className="dispatch-icon" />
          </div>
          <h3 className="card-title">Build</h3>
          <p className="card-description">Delivered at your home</p>
        </div>
      </div>
    </div>
  );
};

export default Promise;